



















import { Component, Prop, Vue, Watch, } from "@/shared/vuepack";
import { HsabExpenseFormType, HsabTransactionDetail } from "@/shared/types";
import Widget from "@/shared/components/Widget.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import HsabTransactionListItem from "@/shared/components/cash/hsabank/HsabTransactionListItem.vue";
import { useHsabHsaAccountTransactionStore } from "@/employee/store/hsabHsaAccountTransaction";
import HsabExpenseDetailsModal
  from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseDetailsModal.vue";
import HsabExpenseEditModal
  from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseEditModal.vue";
import DebitCardTransactionModal
  from "@/employee/components/landing-pages/hsabank/expense/DebitCardTransactionModal.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({
  components: {
    DebitCardTransactionModal,
    HsabExpenseEditModal,
    HsabExpenseDetailsModal,
    Widget,
    HsabTransactionListItem,
    Pagination
  }
})
export default class HsabTransactions extends Vue {
  hsabHsaAccountTransactionStore = useHsabHsaAccountTransactionStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  isLoadingFlowIdChecks = false;
  HsabExpenseFormType = HsabExpenseFormType;

  @Prop()
  page: number;

  @Prop()
  pageCount: number;

  @Prop()
  transactionsForCurrentPage: HsabTransactionDetail[];

  @Prop()
  transactionCount: number;

  @Prop()
  year: string;

  @Prop()
  isNotional: boolean;

  @Prop()
  filterCaption: string;

  mounted () {
    this.checkUncheckedFlowIdsForPage();
  }

  @Watch("transactionsForCurrentPage")
  checkUncheckedFlowIdsForPage () {
    if (!this.isNotional) {
      this.isLoadingFlowIdChecks = true;
      this.hsabHsaAccountTransactionStore.checkUncheckedFlowIdsForTransactions(this.transactionsForCurrentPage).then(
          _ => {
            this.isLoadingFlowIdChecks = false;
          },
          _ => {
            this.isLoadingFlowIdChecks = false;
          }
      );
    }
  }

  get transactionGridItemCount (): number {
    return this.transactionsForCurrentPage.length;
  }

  get widgetTitle () {
    const pluralization = this.transactionsForCurrentPage.length !== 1 ? "s" : "";
    let result = "Showing ";
    if (this.transactionCount <= this.transactionGridItemCount) {
      result += `${this.transactionCount}`;
    } else {
      result += `${this.transactionGridItemCount} of ${this.transactionCount}`;
    }
    if (this.filterCaption) {
      result += ` ${this.filterCaption} Transaction${pluralization}`;
    } else {
      result += ` Transaction${pluralization}`;
    }
    if (this.year) {
      result += ` for ${this.year}`;
    }
    return result;
  }
}
